import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MessageBoxWithIcon = _resolveComponent("MessageBoxWithIcon");
    const _component_AffectedComponent = _resolveComponent("AffectedComponent");
    const _component_PlainDuration = _resolveComponent("PlainDuration");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_MessageBoxWithIcon, {
            class: "mb-4",
            variant: _ctx.BootstrapVariant.INFO,
            "icon-name": "info",
            "icon-title": _ctx.tr('common.INFORMATION')
        }, {
            message: _withCtx(() => [
                _createElementVNode("span", {
                    innerHTML: _ctx.tr('viiu.componentMuting.RESUME_MONITORING_INFO_BOX')
                }, null, 8, _hoisted_1)
            ]),
            _: 1
        }, 8, ["variant", "icon-title"]),
        _createVNode(_component_AffectedComponent, {
            class: "mb-4",
            "component-id": _ctx.modelValue.mutedComponent.componentId,
            "component-type": _ctx.modelValue.mutedComponent.componentType,
            "should-cascade": _ctx.modelValue.shouldCascade,
            "system-id": _ctx.modelValue.systemId
        }, null, 8, ["component-id", "component-type", "should-cascade", "system-id"]),
        _createVNode(_component_PlainDuration, {
            "start-date": _ctx.modelValue.start
        }, null, 8, ["start-date"])
    ], 64));
}
